<script>
import { mapState, mapGetters, mapActions } from "vuex";

export default {
  computed: {
    ...mapState("newPurchase", ["day_of_week", "frequency"])
  },

  methods: {
    ...mapActions("newPurchase", ["setDayOfWeek", "setFrequency"])
  }
};
</script>

<template>
  <div>
    <ul class="week">
      <li :class="{'active': day_of_week === 'Sunday'}" @click="setDayOfWeek('Sunday')">D</li>
      <li :class="{'active': day_of_week === 'Monday'}" @click="setDayOfWeek('Monday')">S</li>
      <li :class="{'active': day_of_week === 'Tuesday'}" @click="setDayOfWeek('Tuesday')">T</li>
      <li :class="{'active': day_of_week === 'Wednesday'}" @click="setDayOfWeek('Wednesday')">Q</li>
      <li :class="{'active': day_of_week === 'Thursday'}" @click="setDayOfWeek('Thursday')">Q</li>
      <li :class="{'active': day_of_week === 'Friday'}" @click="setDayOfWeek('Friday')">S</li>
      <li :class="{'active': day_of_week === 'Saturday'}" @click="setDayOfWeek('Saturday')">S</li>
    </ul>

    <transition name="fade" mode="out-in">
      <ul v-show="day_of_week" class="frequency">
        <li :class="{'active': frequency === 'weekly'}" @click="setFrequency('weekly')">semanal</li>
        <li
          :class="{'active': frequency === 'biweekly'}"
          @click="setFrequency('biweekly')"
        >quinzenal</li>
        <li :class="{'active': frequency === 'monthly'}" @click="setFrequency('monthly')">mensal</li>
      </ul>
    </transition>
  </div>
</template>

<style scoped>
.week,
.frequency {
  margin: 0 0 40px 0;
  padding: 0;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
}

.week li,
.frequency li {
  width: 30px;
  height: 30px;
  border: 1px solid var(--purple);
  color: var(--purple);
  border-radius: 4px;
  list-style: none;
  text-align: center;
  line-height: 30px;
  font-weight: 800;
  margin: 0 5px;
  cursor: pointer;
}

.frequency li {
  font-size: 13px;
  font-weight: 500;
  width: auto;
  padding: 0 18px;
}

.week li.active,
.frequency li.active {
  background-color: var(--purple);
  color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/components/_Shared/OrdersAndSubscriptions/DayAndFrequency.vue